import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FormProps} from 'core/form/formUtils';
import StyledSelect from 'core/components/fields/styledSelect';
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {formatInterval} from "core/common/utils/dateUtils";
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {ActivityTemplate} from "core/event/eventDomain";
import {observer} from "mobx-react";
import {DefinitionType, FIELDDEFDISPLAYTYPE} from "core/form/form";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";



@observer
class ActivityTemplateForm extends React.Component<FormProps<ActivityTemplate, ActivityTemplate>, undefined> {

  render() {

    let {dataObject, rootObject, entity, entities} = this.props;
    let fields = dataObject.getFormFields(definition.formName);
    let {comment, validFrom, validTo, language, defaultEmailSubject, templateIndex, profitCenter, emailFrom, replyTo, cc, bcc, toAddress, activityPaths, backOfficeEmail} = fields;

    let openContent = (
      <div>


        <div className="row">
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...profitCenter.props} />
          </div>
          <div className="fx col-xs-12 col-sm-4">
            <StyledSelect {...language.props} />
          </div>
          <div className="col-xs-12 col-sm-4">
            <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value} onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange} />
          </div>
        </div>


        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...emailFrom.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...replyTo.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...toAddress.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...cc.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...bcc.props} />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <MdTextField {...backOfficeEmail.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <StyledSelect {...activityPaths.props} />
          </div>
        </div>

        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...defaultEmailSubject.props} multiLine={true} rows={2} />
          </div>
        </div>


        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={2}  />
          </div>
        </div>

      </div>
    );



    return (
      <BlockComp noPadding >
        <ActiveItem openContent={openContent} openClassName="active-item" closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} /> } validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}



const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ActivityTemplate>) => (
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} >
      <ClosedFormField label={fields.templateIndex.textLabel} value={dataObject.templateIndex}/>
      <ClosedFormField label={fields.language.textLabel} value={dataObject.language}/>
      <ClosedFormField label={fields.profitCenter.textLabel} value={dataObject.profitCenter}/>
      <ClosedFormField label={fields.validFrom.textLabel} value={formatInterval(dataObject.validFrom, dataObject.validTo)}/>
      <ClosedFormField label={fields.emailFrom.textLabel} value={dataObject.emailFrom}/>
      <ClosedFormField label={fields.replyTo.textLabel} value={dataObject.replyTo}/>
      <ClosedFormField label={fields.toAddress.textLabel} value={dataObject.toAddress}/>
      <ClosedFormField label={fields.cc.textLabel} value={dataObject.cc}/>
      <ClosedFormField label={fields.bcc.textLabel} value={dataObject.bcc}/>
      <ClosedFormField label={fields.backOfficeEmail.textLabel} value={dataObject.backOfficeEmail}/>
      <ClosedFormField label={fields.activityPaths.textLabel} value={dataObject.activityPaths}/>
      <ClosedFormField label={fields.defaultEmailSubject.textLabel} value={dataObject.defaultEmailSubject}/>
      <ClosedFormField label={fields.comment.textLabel} value={dataObject.comment}/>

    </ClosedFormBlock>
);


const definition: DefinitionType = {
  formName: 'ActivityTemplateForm',
  fields: [{
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }, {
    name: 'profitCenter'
  }, {
    name: 'language'
  }, {
    name: 'emailFrom'
  }, {
    name: 'replyTo'
  }, {
    name: 'toAddress'
  }, {
    name: 'cc'
  }, {
    name: 'bcc'
  }, {
    name: 'backOfficeEmail'
  }, {
    name: 'activityPaths'
  }, {
    name: 'templateIndex'
  }, {
    name: 'defaultEmailSubject',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }]
};

export default createForm(definition, ClosedContent)(ActivityTemplateForm);



// WEBPACK FOOTER //
// ./src/core/event/component/activityTemplateForm.tsx